<template>
  <div class="company-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="companyModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="名称" prop="name">
            <Input v-model="companyModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="社会信用代码" prop="businessLicense">
            <Input v-model="companyModel.businessLicense" placeholder="输入社会信用代码" />
          </FormItem>
          <FormItem label="法人姓名" prop="legalPersonName">
            <Input v-model="companyModel.legalPersonName" placeholder="输入社会信用代码" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Select v-model="companyModel.type" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.companyType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="是否本省" prop="isLocal">
            <i-switch v-model="companyModel.isLocal" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="城市" prop="regCity" v-if="companyModel.isLocal">
            <!-- <Input v-model="industryModel.cityId" placeholder="输入城市" /> -->
            <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择城市"></Cascader>
          </FormItem>
          <FormItem label="营业地址" prop="address">
            <Input v-model="companyModel.address" placeholder="输入营业地址" />
          </FormItem>
          <FormItem label="电子邮件" prop="email">
            <Input v-model="companyModel.email" placeholder="输入电子邮件" />
          </FormItem>
          <FormItem label="联系人" prop="contact">
            <Input v-model="companyModel.contact" placeholder="输入联系人" />
          </FormItem>
          <FormItem label="联系人电话" prop="contactTel">
            <Input v-model="companyModel.contactTel" placeholder="输入联系人电话" />
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'company-new',
  props: {
  },
  data () {
    return {
      loading: false,
      companyModel: {
        name: null,
        businessLicense: null,
        legalPersonName: null,
        contact: null,
        contactTel: null,
        regCity: null,
        address: null,
        email: null,
        isLocal: true
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: '请填写社会信用代码', trigger: 'blur' }
        ],
        legalPersonName: [
          { required: true, message: '请填写法人姓名', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请填写联系人', trigger: 'blur' }
        ],
        contactTel: [
          { required: true, message: '请填写联系电话', trigger: 'blur' }
        ]
      },
      cities: []
    }
  },
  watch: {
  },
  mounted () {
    this.initCitySelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.companyModel.regCity = val[val.length - 1]
      } else {
        this.companyModel.regCity = val
      }
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Company.addCompany(this.companyModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.companyModel= {
                name: null,
                businessLicense: null,
                legalPersonName: null,
                contact: null,
                contactTel: null,
                regCity: null,
                address: null,
                email: null,
                isLocal: true
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
